import baseAssignValue from "./component-library337.mjs";
import baseForOwn from "./component-library338.mjs";
import baseIteratee from "./component-library304.mjs";
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee);
  baseForOwn(object, function(value, key, object2) {
    baseAssignValue(result, iteratee(value, key, object2), value);
  });
  return result;
}
export {
  mapKeys as default
};
